import fetch from 'isomorphic-fetch';
import { EventTypes } from 'redux-segment';
import * as ActionType from './types/OnboardActionTypes';

export function resetStep() {
  return {
    type: ActionType.RESET_STEP
  };
}

export function incStep() {
  return (dispatch, getState) => {
    const nextStep = getState().Onboard.step + 1;
    dispatch({
      type: ActionType.INC_STEP,
      meta: {
        analytics: [
          {
            eventType: EventTypes.page,
            eventPayload: {
              properties: {
                path: `/wedding/onboard/step-${nextStep}`
              }
            },
          },
        ],
      }
    });
  };
}
export function decStep() {
  return (dispatch, getState) => {
    const nextStep = getState().Onboard.step - 1;
    dispatch({
      type: ActionType.DEC_STEP,
      meta: {
        analytics: [
          {
            eventType: EventTypes.page,
            eventPayload: {
              properties: {
                path: `/wedding/onboard/step-${nextStep}`
              }
            },
          },
        ],
      }
    });
  };
}

export function checkingSlug() {
  return {
    type: ActionType.CHECK_SLUG_AVAILABLE
  };
}

// sets which product the user is primarily using
// based on pkey or user selection
export function setPrimaryProduct(productKey) {
  return {
    type: ActionType.PRIMARY_PRODUCT_SELECTED,
    payload: productKey
  };
}

export function receiveSlugAvailability(response) {
  return {
    type: ActionType.SLUG_AVAILABILITY_RECEIVED,
    payload: response.data
  };
}

export function receiveSlugSuggestions(response) {
  return {
    type: ActionType.SLUG_SUGGESTIONS_RECEIVED,
    payload: response.data
  };
}

export function checkSlugAvailability(slug) {
  return (dispatch) => {
    dispatch(checkingSlug());
    return fetch(`/web-api/v1/wedding/slug/${slug}/available`,
      {
        credentials: 'same-origin',
      })
      .then(response => response.json())
      .then(json => dispatch(receiveSlugAvailability(json)))
      .then(action => action);
  };
}

export function getSlugSuggestions(suggestionData) {
  const { primaryFirstName, partnerFirstName, primaryLastName, partnerLastName, eventDate } = suggestionData;
  return (dispatch) => {
    dispatch(checkingSlug());
    const dateSuggestion = eventDate || '';
    return fetch(`/web-api/v1/wedding/slug/suggestions?primaryFirstName=${primaryFirstName}&partnerFirstName=${partnerFirstName}&primaryLastName=${primaryLastName}&partnerLastName=${partnerLastName}&eventDate=${dateSuggestion}`,
      {
        credentials: 'same-origin'
      })
      .then(response => response.json())
      .then(json => dispatch(receiveSlugSuggestions(json)));
  };
}



/** WEBPACK FOOTER **
 ** ./src/actions/OnboardActions.js
 **/